<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div :class="[$style['scroller-model'], 'mb-10']">
                <div :class="$style['scroller-view']">
                    <scroller 
                      :on-refresh="refresh"
                      :on-infinite="infinite"
                      :noDataText="noDataText"
                      ref="my_scroller">
                        <ul>
                            <li v-for="list in lists" :key="list">{{ list }}</li>
                        </ul>
                    </scroller>
                </div>
            </div>
            <div :class="[$style['scroller-view'], 'mb-10']">
                <table :class="$style.table">
                    <thead>
                        <tr>
                            <th :class="$style['table-th']" v-for="(h, index) in table_data.h" :key="index + h">{{ h }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(b, index) in table_data.b" :key="index">
                            <td :class="$style['table-td']" v-for="(b_v, i) in b" :key="index + '' + i">{{ b_v }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="fs-13 mb-10">
                <h4 class="mb-10">使用的坑</h4>
                <p class="mb-05">
                    1、做的功能中左右切换使用的是同一个scroller，当一个数据加载完毕，切换到另外一个，不可以上拉获取数据。
                </p>
                <p class="mb-05">
                    在切换tab页的时候调用this.$refs.my_scroller.finishInfinite(false)
                </p>
                <p class="mb-10">
                    finishInfinite函数为scroller实例的方法，当参数为false时，上拉获取数据可以重新调用。当参数为true，上拉获取数据回调函数停止使用,下拉下部不再显示loading，会显示‘’暂无更多数据。
                </p>
                <p class="mb-05">
                    2、下拉刷新，刷新完毕，loading动画一直存在不消失。
                </p>
                <p class="mb-05">
                    需要手动调用finishPullToRefresh。停止下拉刷新。
                </p>
                <p class="mb-10">
                    调用方式：this.$refs.my_scroller.finishPullToRefresh();
                </p>
                <p class="mb-05">
                    3、infinite的回调函数done调用时间
                </p>
                <p>
                    将后台获取的数据，复制到vue组件的数据源后，再进行调用done函数。如果在之前调用,会循环调用。如果不调用这个函数，上拉获取数据函数调用不成功。
                </p>
            </div>
            <div class="fs-13">
                <h4 class="mb-10">Scroller vm instance methods:</h4>
                <p class="mb-05">resize() resize scroller content (已经废弃)</p>
                <p class="mb-05">triggerPullToRefresh() 触发下拉刷新</p>
                <p class="mb-05">finishPullToRefresh() 完成下拉刷新.可以手动调用</p>
                <p class="mb-05">finishInfinite(isNoMoreData :Boolean) 当参数为false时，上拉获取数据可以重新调用。当参数为true，上拉获取数据回调函数停止使用,下拉下部不再显示loading，会显示‘’暂无更多数据</p>
                <p class="mb-05">scrollTo(x:Integer, y:Integer, animate:Boolean) scroll to a position in scroller content</p>
                <p class="mb-05">scrollBy(x:Integer, y:Integer, animate:Boolean) scroll by a position in scroller content</p>
                <p class="mb-05">getPosition :Object get current position of scroller content</p>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    export default{
        name:'vue-scroller',
        data(){
            return {
                lists:20,
                noDataText:'我也是有底线的',
                table_data:{
                    h:['Attr. Name', 'Description', 'Required', 'Default Value'],
                    b:[
                        ['onRefresh', '下拉刷新', 'N', '-'],
                        ['onInfinite', '上拉获取数据', 'N', '-'],
                        ['refreshText', 'pull-to-refresh的提示信息', 'N', '下拉刷新'],
                        ['noDataText', '当全部数据加载完毕提示信息', 'N', '没有更多数据'],
                        ['width', 'scroller container width', 'N', '100%'],
                        ['height', 'scroller container height', 'N', '100%'],
                        ['snapping', 'enable snapping mode', 'N', 'false'],
                        ['snappingWidth', 'snapping width', 'N', '100 (stand for 100px)'],
                        ['snappingHeight', 'snapping height', 'N', '100'],
                        ['refreshLayerColor', 'text color of pull-to-refresh layer', 'N', '#AAA'],
                        ['loadingLayerColor', 'text color of infinite-loading layer', 'N', '#AAA'],
                        ['minContentHeight', 'min content height (px) of scroll-content', 'N', '0'],
                    ]
                }
            }
        },
        created(){
            this.$parent.routerLoading();
        },
        methods:{
            /**
             * 下拉刷新
             */
            refresh() {
              console.log("refresh");
              this.timeout = setTimeout(()=>{
                this.$refs.my_scroller.finishPullToRefresh(false)
              }, 1500)
            },

            /**
             * 上拉获取
             */
            infinite(done) {
              console.log("infinite");
              this.timeout = setTimeout(()=>{
                this.$refs.my_scroller.finishPullToRefresh()
              }, 1500)
            },
            /**
             * 左右滑动设置初始值
             */
            setInitParas(){
              this.pageNumber = 1;
              this.setloadingshow();
              this.items=[]
              this.$refs.my_scroller.finishInfinite(false);
            },
            /**
             * 获取台账列表参数信息
             */
            getOrderParams(index) {
              //index为1表示已验货,0表示未验货 2
              let dbconsignee_phone = localStorage.getItem("dbconsignee_phone");
              var searchData = {
                dbordernumber: "", //提货单号
                dbconsignee_phone: dbconsignee_phone, //手机号码
                acceptance_status: index,
                pageSize:5, //一页多少数
                pageNumber: this.pageNumber, //页码
                order: "",
                sort: ""
              };
              return searchData;
            },

            setloadingshow() {
              this.$vux.loading.show({
                text: "加载中"
              });
            },

            /**
             * 获取台账列表信息
             */
            getOrderList(index, done) {
              const that = this;
              this.selectTabIndex = index;
              const searchData = this.getOrderParams(this.selectTabIndex);
              const params = {
                url: "/receiver/bill/order/datalist",
                reqparams: {
                  cmdData: JSON.stringify(searchData)
                },
                onSuccess(data) {
                  that.$vux.loading.hide();
                  const billJson = JSON.parse(data);
                  const newOrderItem = that.formatterOrderData(billJson.rows);
                  if (newOrderItem.length > 0) {
                    that.items = that.items.concat(newOrderItem);
                  }
                  if(typeof(done)=="function"){
                    done();
                  }
                  that.$refs.my_scroller.finishPullToRefresh();
                  if ( that.pageNumber >= billJson.pageCount ||billJson.pageCount == 0 ) {
                    that.$refs.my_scroller.finishInfinite(true);
                  }
                }
              };
              http.getData(params);
            },
        }
    }
</script>
<style module>
    .scroller-model{
        height: 200px;
        padding: 10px;
    }
    .scroller-view{
        height: 100%;
        position: relative;
    }
    .table{
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
        width: 100%;
        text-align: left;
    }
    .table-td, .table-th{
        padding: 10px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/vue-scroller.vue